import { EntityIconLg } from '@components/core-ui/EntityIcon/variations/EntityIconLg';

import { Actions } from './components/Actions';
import { TProps } from './types/TProps';

const wrapperClassName = 'col-span-1 flex h-[72px] rounded-[5px]';

const cardClassName =
  'card flex flex-1 items-center justify-between whitespace-nowrap rounded-[5px] bg-[var(--color-surface)]';

const cardTextClassName =
  'card-text w-40 flex-1 overflow-hidden text-ellipsis whitespace-nowrap p-2.5 text-sm leading-5';

export const UniversalCard = ({
  image,
  name,
  backgroundColor,
  onClick,
  content,
  actions,
  className = 'universal-card',
}: TProps) => {
  return (
    <div className={[wrapperClassName, className].filter(Boolean).join(' ')}>
      <EntityIconLg
        name={name}
        src={image ?? undefined}
        backgroundColor={image ? 'var(--color-surface)' : backgroundColor}
        color={backgroundColor ? 'var(--color-surface)' : 'var(--color-avatar-text)'}
        onClick={onClick}
        className="entity-icon cursor-pointer"
      />
      <div className={cardClassName}>
        <div className={cardTextClassName}>{content}</div>
        {actions?.length && actions.length > 0 ? <Actions actions={actions} /> : null}
      </div>
    </div>
  );
};
